export default {
  MuiSwitch: {
    root: {
      width: 71,
      height: 32,
      padding: 0,
      display: 'flex',
    },
    switchBase: {
      padding: 4,
      color: '#BDBDBD',
      '&$checked': {
        transform: 'translateX(39px)',
        color: '#26A69A',
      },
    },
    colorPrimary: {
      '&.Mui-checked': {
        color: '#26A69A',
      },
      '&.Mui-disabled': {
        color: '#BDBDBD',
      },
    },
    thumb: {
      width: 24,
      height: 24,
      boxShadow: 'none',
    },
    track: {
      border: '1px solid #26A69A',
      borderRadius: 24,
      backgroundColor: '#FFFFFF',
      '$checked$checked + &': {
        backgroundColor: '#fff',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Switch.js